import Icon from '../components/Icon.vue'

Icon.register({
  comment: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32C114.6 32 0 125.1 0 240 0 289.6 21.4 335 57 370.7 44.5 421.1 2.7 466 2.2 466.5 0 468.8-0.6 472.2 0.7 475.2S4.8 480 8 480C74.3 480 124 448.2 148.6 428.6 181.3 440.9 217.6 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment.js
// module id = oSoA
// module chunks = 144